import React, { useState, useEffect } from 'react';
import WordDisplay from './components/WordDisplay';
import CategorySelector from './components/CategorySelector';
import DifficultySelector from './components/DifficultySelector';
import InstallPrompt from './components/InstallPrompt';
import { getRandomWord } from './data/wordService';
import './styles/App.css';

function App() {
  const [currentWord, setCurrentWord] = useState('');
  const [selectedCategories, setSelectedCategories] = useState(['animals', 'objects']); // Default to 2 categories
  const [selectedDifficulties, setSelectedDifficulties] = useState(['easy', 'medium']); // Default to easy + medium
  const [isLoading, setIsLoading] = useState(false);

  const generateNewWord = async () => {
    setIsLoading(true);
    try {
      const word = await getRandomWord(selectedCategories, selectedDifficulties);
      setCurrentWord(word);
    } catch (error) {
      console.error('Error generating word:', error);
      setCurrentWord('Error loading word');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    generateNewWord();
  }, [selectedCategories, selectedDifficulties]);

  return (
    <div className="app">
      <header className="app-header">
        <h1>Guess It!</h1>
        <p>Drawing Game Word Generator</p>
      </header>

      <main className="app-main">
        <div className="controls">
          <CategorySelector
            selectedCategories={selectedCategories}
            onCategoryChange={setSelectedCategories}
          />
          <DifficultySelector
            selectedDifficulties={selectedDifficulties}
            onDifficultyChange={setSelectedDifficulties}
          />
        </div>

        <WordDisplay
          word={currentWord}
          isLoading={isLoading}
          onNewWord={generateNewWord}
        />
      </main>

      <InstallPrompt />
    </div>
  );
}

export default App;